import CSDashoboard from "../construction_services/cs_dashboard";
import CSReportPage from "../construction_services/cs_report_page";
import UserPage from "../global/user_page";
import FieldReportPage from "../field_services/fs_report_page";
import ReliabilityReportPage from "../reliability_services/rs_report_page";
import ReliabilityDashboard from "../reliability_services/rs_dashboard";
import ReliabilityDashboardUG from "../reliability_services_UG/rs_dashboard";
import ReliabilityReportPageUG from "../reliability_services_UG/rs_report_page";

import MapPage from "./map_page";

import { useProject } from '../../contexts/ProjectContext';
import { useEnvironmentConfigContext } from '../../contexts/EnvironmentConfigContext'; 

export function DashboardWrapper() {
    const { segment, selectedProject } = useProject();
    const Element = segment == "Doublewood" ? <CSDashoboard /> : segment == "Underground" ? <ReliabilityDashboardUG /> : <ReliabilityDashboard />;
    return Element;
}

//for when the map and dasboard are seperated
export function MapWrapper() {
    const { segment, selectedProject } = useProject();
    const Element = <MapPage />;
    return Element;
}

export function UserWrapper() {
    //Currently there is only one user page across all segments
    //Abstraction exists in case we need to have multiple user pages for whatever reason
    return <UserPage />;
}

export function ReportWrapper() {
    const { segment, selectedProject, hasMeterTable } = useProject();

    if (hasMeterTable) {
        return <FieldReportPage />;
    } else if (segment === "Doublewood") {
        return <CSReportPage />;
    } else if (segment === "Underground") {
        return <ReliabilityReportPageUG />;
    } else {
        return <ReliabilityReportPage />;
    }
}